import type { PartialTheme } from '@nivo/theming';

export function buildNivoTheme(): PartialTheme {
    const style = getComputedStyle(document.body);
    const labelsColor = style.getPropertyValue('--chart-labels-color');
    const labelsFont = style.getPropertyValue('--chart-labels-font');
    const ticksColor = style.getPropertyValue('--chart-ticks-color');
    const gridColor = style.getPropertyValue('--chart-grid-color');

    return {
        text: { fill: labelsColor, fontFamily: labelsFont },
        axis: {
            ticks: { text: { fill: ticksColor, fontFamily: labelsFont } },
            legend: { text: { fill: labelsColor, fontFamily: labelsFont } }
        },
        grid: { line: { stroke: gridColor, strokeWidth: 1 } },
        legends: { text: { fill: labelsColor, fontFamily: labelsFont } },
        tooltip: {
            container: { color: '#ffffff', background: 'rgba(0, 0, 0, 0.85)' },
            // TableTooltip's table renders at width:100% of its shrink-to-fit wrapper, so once
            // a party name is long enough the wrapper settles on a narrow width and the name
            // wraps across several lines. Keep cells on one line so the tooltip grows wider instead.
            tableCell: { whiteSpace: 'nowrap' }
        }
    };
}

// Ports the Chart.js '30'-hex-alpha-suffix dim trick used across legend hover handlers.
export function withAlpha(color: string, alphaHex = '30'): string {
    return color && color.length === 7 && color.startsWith('#') ? color + alphaHex : color;
}

// Unlike Chart.js's legend (which auto-wraps to fit its container), Nivo lays legend
// items out in a fixed-width single row, so long party/geo names must be shortened to
// avoid adjacent items' text overlapping.
export function truncateLegendLabel(label: string, maxLength = 22): string {
    return label.length > maxLength ? `${label.slice(0, maxLength - 1).trimEnd()}…` : label;
}
